import React, { useContext } from 'react'

import { access } from '@driftt/traffic-control'

import AccountFitBreakdownTooltip from 'components/AccountFitTooltip/AccountFitBreakdownTooltip'
import { ICPSettingsContext } from 'context/icpSettingsContext'
import { CompanyData, ScoreBreakdown } from 'modules/accountActivity/domain'

import ICPInfoTooltip from './ICPInfoTooltip'

export const AccountFitTooltip = ({
  accountFitScore,
  companyData,
  scoreBreakdown
}: {
  accountFitScore: number | undefined
  companyData: CompanyData | undefined
  scoreBreakdown: ScoreBreakdown | undefined
}) => {
  const isAdmin = access.isAdmin()

  const { hideScoresBehindLock } = useContext(ICPSettingsContext)

  if (!hideScoresBehindLock) {
    return (
      <AccountFitBreakdownTooltip
        companyData={companyData}
        score={accountFitScore}
        scoreBreakdown={scoreBreakdown}
      />
    )
  } else {
    return <ICPInfoTooltip isAdmin={isAdmin} />
  }
}

export default AccountFitTooltip
